import React from "react";
import T from "prop-types";
import { Col } from "react-bootstrap";
import { Field } from "redux-form";
import { connect } from "react-redux";
import * as actions from "MODULES/companies/actions";
import {
  form,
  Form as AppForm,
  FormRow,
  Check,
  FormInput,
  CheckGroup
} from "MODULES/shared/components/Forms";
import { INCOMING_LINE_ITEMS } from "MODULES/IncomingQuotes/constants";

export function Form(props) {
  return (
    <AppForm {...props}>
      <AppForm.Body>
        <FormRow className="row row-col-gutters-half">
          <Col md={6}>
            <div className="form-group">
              <label className="control-label" htmlFor="none">
                Restrictions
              </label>
              <div
                className="btn-group btn-group-justified btn-group-vertical"
                data-toggle="buttons"
              >
                <Field
                  name="no_pmas_accepted"
                  component={Check}
                  label="No PMAs Accepted"
                />
                <Field
                  name="no_ders_accepted"
                  component={Check}
                  label="No DERs Accepted"
                />
              </div>
            </div>
          </Col>
          <Col md={6}>
            <Field
              name="warranty_minimum"
              type="number"
              component={FormInput}
              label="Warranty Minimum"
            />
          </Col>
        </FormRow>
        <FormRow>
          <Col md={6}>
            <div className="form-group">
              <label className="control-label" htmlFor="none">
                Unaccepted Trace Types
              </label>
              <div
                className="btn-group btn-group-justified btn-group-vertical"
                data-toggle="buttons"
              >
                {Object.keys(INCOMING_LINE_ITEMS.traceTypes).map(k => (
                  <Field
                    name={`trace_type_${k}`}
                    component={Check}
                    label={INCOMING_LINE_ITEMS.traceTypes[k].label}
                  />
                ))}
              </div>
            </div>
          </Col>
          <Col md={6}>
            <CheckGroup justified title="Imperfect Trace Approval Required">
              <Field name="imperfect_trace" component={Check} label="Yes" />
            </CheckGroup>
          </Col>
        </FormRow>
      </AppForm.Body>
    </AppForm>
  );
}

Form.propTypes = {
  company: T.shape({})
};

export default connect(undefined, dispatch => ({
  onSubmit: data => {
    data.unaccepted_trace_types = Object.keys(data)
      .filter(
        f =>
          f.includes("trace_type") && data[f] && f !== "unaccepted_trace_types"
      )
      .map(f => f.replace("trace_type_", ""));
    return dispatch(actions.update(data));
  }
}))(
  form({
    form: "editCustomerRestrictions"
  })(Form)
);



// WEBPACK FOOTER //
// ./app/modules/companies/components/Detail/CustomerRestrictionsTable/Form.jsx